export const NotificationModal = () => import(/* webpackChunkName: "notification" */ '@shared/components/notification/NotificationModal.vue');
export const NotificationItemPop = () => import(/* webpackChunkName: "notification" */ '@shared/components/notification/NotificationItemPop.vue');
